// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/retractable-gear-operation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/retractable-gear-operation/retractable-gear-operation.js';

mount([g0]);
